import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const PlatformBenefits = () => {
  const benefits = [
    {
      icon: 'Target',
      title: 'Voor Projectleiders',
      description: 'Vind snel het juiste personeel voor uw verduurzamingsproject',
      features: [
        'Directe toegang tot 1.800+ gecertificeerde vakmensen',
        'Transparante tarieven en beoordelingen',
        'Veilige contractbeheer en planning',
        'Real-time communicatie en beschikbaarheid'
      ]
    },
    {
      icon: 'Briefcase',
      title: 'Voor Vakmensen',
      description: 'Groei uw carrière met meer projecten',
      features: [
        'Toegang tot verduurzamingsprojecten',
        'Flexibel werken op eigen voorwaarden',
        'Eerlijke tariefstructuur',
        'Professioneel profiel en portfolio'
      ]
    },
    {
      icon: 'Handshake',
      title: 'Voor Partners',
      description: 'Verdien commissie door personeel te verbinden',
      features: [
        'Aantrekkelijke commissiestructuur',
        'Real-time inzicht in opbrengsten',
        'Eigen dashboard met statistieken',
        'Ondersteuning en marketing materiaal'
      ]
    }
  ];

  return (
    <section id="benefits" className="py-20 md:py-28 bg-[#0A0A0A] relative overflow-hidden">
      <div className="absolute top-1/2 left-0 w-80 h-80 rounded-full blur-[140px] opacity-5" style={{ background: '#00E5A0' }} />
      <div className="max-w-6xl mx-auto px-6 lg:px-8 relative z-10">
        <motion.div
          className="mb-14"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <motion.p className="text-xs font-body font-medium tracking-[0.2em] uppercase mb-4" style={{ color: '#00E5A0' }}>
            — Voordelen
          </motion.p>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-white mb-4 leading-tight">
            Voordelen voor iedereen
          </h2>
          <p className="text-base max-w-xl" style={{ color: '#888888' }}>
            Of je nu personeel zoekt, projecten uitvoert of bemiddelt — BVM Group biedt de tools die je nodig hebt
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-px mb-px" style={{ background: '#1A1A1A' }}>
          {benefits?.map((benefit, index) => (
            <motion.div
              key={index}
              className="p-8"
              style={{ background: '#0A0A0A' }}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ background: '#0F0F0F' }}
            >
              <div className="w-10 h-10 rounded flex items-center justify-center mb-6" style={{ border: '1px solid #2A2A2A' }}>
                <Icon name={benefit?.icon} size={20} color="#00E5A0" />
              </div>
              <h3 className="text-xl font-heading font-semibold text-white mb-2">{benefit?.title}</h3>
              <p className="text-sm mb-6" style={{ color: '#666666' }}>{benefit?.description}</p>
              <ul className="space-y-3">
                {benefit?.features?.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <div className="w-4 h-4 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{ background: 'rgba(0,229,160,0.15)' }}>
                      <Icon name="Check" size={10} color="#00E5A0" />
                    </div>
                    <span className="text-sm" style={{ color: '#888888' }}>{feature}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        {/* How it works */}
        <motion.div
          className="p-8 md:p-12"
          style={{ background: '#0D0D0D', border: '1px solid #1A1A1A' }}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
            <div>
              <p className="text-xs font-body font-medium tracking-[0.2em] uppercase mb-4" style={{ color: '#00E5A0' }}>— Hoe het werkt</p>
              <h3 className="text-3xl font-heading font-bold text-white mb-4">In vier stappen verbonden</h3>
              <p className="text-sm" style={{ color: '#666666' }}>In slechts vier eenvoudige stappen verbinden we projecten met de juiste vakmensen</p>
            </div>
            <div className="space-y-5">
              {[
                { step: '01', title: 'Registreer', desc: 'Maak een account aan als projectleider, vakman of partner' },
                { step: '02', title: 'Plaats of vind opdrachten', desc: 'Plaats een personeelsvraag of browse door beschikbare projecten' },
                { step: '03', title: 'Verbind en communiceer', desc: 'Match met de juiste vakman en communiceer direct' },
                { step: '04', title: 'Voltooi en beoordeel', desc: 'Voltooi het project en laat een beoordeling achter' }
              ]?.map((item, index) => (
                <motion.div
                  key={index}
                  className="flex items-start gap-4"
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                >
                  <span className="text-xs font-body font-bold tracking-widest flex-shrink-0 mt-1" style={{ color: '#00E5A0' }}>{item?.step}</span>
                  <div>
                    <h4 className="text-sm font-body font-semibold text-white mb-1">{item?.title}</h4>
                    <p className="text-xs" style={{ color: '#666666' }}>{item?.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default PlatformBenefits;